import { render, staticRenderFns } from "./TaskShare.vue?vue&type=template&id=bc511246&"
import script from "./TaskShare.vue?vue&type=script&lang=js&"
export * from "./TaskShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports